import React, { Component } from 'react'

class Screen6 extends Component {

  render() {

    const { addEntry, language, t } = this.props

    return (
      <main className="edit_screen">
        <h3>{t(language, 'photoOrScreenshot')}</h3>
        <p style={{marginBottom: 40}}>{t(language, 'uploadEvidence')}</p>
        <label>{t(language, 'photos')}
          <input type="file" onChange={(e) => addEntry('photo_1', null, e)} />
          <input type="file" onChange={(e) => addEntry('photo_2', null, e)} />
          <input type="file" onChange={(e) => addEntry('photo_3', null, e)} />
        </label>
      </main>
    );
  }
}

export default Screen6;
